import { useMemo } from 'react';
import { TagCalculation } from '../types';

interface UseTagCalculationProps {
  value?: string[];
  containerWidth: number;
  measureTextWidth: (text: string, fontSize?: string) => number;
}

export const useTagCalculation = ({
  value,
  containerWidth,
  measureTextWidth,
}: UseTagCalculationProps): TagCalculation | null => {
  return useMemo(() => {
    if (!value?.length || !containerWidth) return null;

    const numTags = value.length;
    const reservedWidth = 66; // Reserve space for the "+X" chip
    const availableWidth = containerWidth - reservedWidth;
    const commaWidth = measureTextWidth(',', '0.75rem');

    const sortedValue = [...value].sort((a, b) => a.length - b.length);
    const tagWidths = sortedValue.map((option) => measureTextWidth(option, '0.75rem'));

    let usedWidth = 0;
    let limitTags = 0;

    for (let i = 0; i < tagWidths.length; i++) {
      const tagWidth = tagWidths[i];
      const commaSpace = i > 0 ? commaWidth : 0;
      const projectedWidth = usedWidth + tagWidth + commaSpace;

      const needsPlusChip = i < tagWidths.length - 1;
      const plusChipWidth = needsPlusChip ? measureTextWidth(`+${numTags - (i + 1)}`, '0.75rem') + 20 : 0;

      if (projectedWidth + plusChipWidth <= availableWidth) {
        usedWidth = projectedWidth;
        limitTags = i + 1;
      } else {
        break;
      }
    }

    return {
      sortedValue,
      limitTags,
      numTags,
    };
  }, [value, containerWidth, measureTextWidth]);
};
